module.exports = __webpack_public_path__ + "img/chinesecompany205.4799dbeb.png";